// extracted by mini-css-extract-plugin
module.exports = {"container":"Wagon_container__1wTea","icon":"Wagon_icon__2vJLo"};